"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynthesizeAudioPostService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class SynthesizeAudioPostService {
    /**
     * Speech synthesis service.
     *
     * Вход JSON: {"text":"...", "lang_id":5}
     * Выход: audio/mpeg
     * @returns any No response body
     * @throws ApiError
     */
    static synthesizeAudioPostCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/synthesize_audio_post',
        });
    }
}
exports.SynthesizeAudioPostService = SynthesizeAudioPostService;
